var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcederIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.3L13.3 9.5L9.5 5.7L8.17 7.03L9.68999 8.55H5.7V10.45H9.68999L8.17 11.97L9.5 13.3ZM9.5 19C8.18583 19 6.95083 18.7505 5.795 18.2514C4.63917 17.7523 3.63375 17.0756 2.77875 16.2212C1.92375 15.3669 1.24703 14.3615 0.748601 13.205C0.250168 12.0485 0.000634535 10.8135 1.20253e-06 9.5C-0.00063213 8.18646 0.248901 6.95147 0.748601 5.795C1.2483 4.63853 1.92502 3.63312 2.77875 2.77875C3.63248 1.92438 4.6379 1.24767 5.795 0.7486C6.9521 0.249533 8.1871 0 9.5 0C10.8129 0 12.0479 0.249533 13.205 0.7486C14.3621 1.24767 15.3675 1.92438 16.2212 2.77875C17.075 3.63312 17.752 4.63853 18.2523 5.795C18.7527 6.95147 19.0019 8.18646 19 9.5C18.9981 10.8135 18.7486 12.0485 18.2514 13.205C17.7542 14.3615 17.0775 15.3669 16.2212 16.2212C15.365 17.0756 14.3596 17.7526 13.205 18.2523C12.0504 18.752 10.8154 19.0013 9.5 19ZM9.5 17.1C11.6217 17.1 13.4187 16.3637 14.8912 14.8912C16.3637 13.4187 17.1 11.6217 17.1 9.5C17.1 7.37833 16.3637 5.58125 14.8912 4.10875C13.4187 2.63625 11.6217 1.9 9.5 1.9C7.37833 1.9 5.58125 2.63625 4.10875 4.10875C2.63625 5.58125 1.9 7.37833 1.9 9.5C1.9 11.6217 2.63625 13.4187 4.10875 14.8912C5.58125 16.3637 7.37833 17.1 9.5 17.1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcederIcon);
export default __webpack_public_path__ + "static/media/proceder-icon.72e5c9e0d6d8da994c80a3487c10b987.svg";
export { ForwardRef as ReactComponent };